import { Stack } from '@mantine/core';
import { useState } from 'react';
import { RelativeFile } from '@/types/common';
import AddStaticDatasetModal from '@/pages/Editor/components/StepSidebar/DataSources/AddStaticDatasetModal';
import CustomDropZone from '@/components/CustomDropZone';

const UploadNewFiles = () => {
  const [datasetName, setDatasetName] = useState<string>('');
  const [files, setFiles] = useState<RelativeFile[]>([]);

  const handleSetFiles = (newFiles: RelativeFile[], name?: string) => {
    // name comes from directory name or single filename (from CustomDropZone)
    if (name) {
      setDatasetName(name);
    } else if (newFiles.length === 1) {
      setDatasetName(newFiles[0].file.name);
    } else {
      setDatasetName('');
    }
    setFiles(newFiles);
  };

  return (
    <Stack gap="xs">
      <CustomDropZone mode="multiple" files={files} setFiles={handleSetFiles} height="60px" />

      <AddStaticDatasetModal
        setDatasetName={setDatasetName}
        datasetName={datasetName}
        files={files}
        setFiles={setFiles}
        opened={files.length > 0}
        onClose={() => {
          setFiles([]);
          setDatasetName('');
        }}
      />
    </Stack>
  );
};

export default UploadNewFiles;
